<template>
  <DragDialog
    title="转换队列"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
  >
    <div class="queue-list-box">
      <div v-if="tableLoading">
        <Spin :pointNum="8" :translateX="25" background="var(--base-primary-bgColor)"  />
      </div>
      <div class="common-table-box" v-else>
        <el-table height="100%" class="publish-table" highlight-selection-row :data="queueList">
          <el-table-column label="序号" type="index" width="75" />
          <el-table-column label="转换节点">
            <template v-slot="{ row }">
              <span>{{ row.zoneId ? row.zoneId : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="队列名称">
            <template v-slot="{ row }">
              <span>{{ row.queueName ? row.queueName : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="文件名称">
            <template v-slot="{ row }">
              <span class="text-overflow" :title="row.dataSetName">{{
                row.dataSetName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="文件大小">
            <template v-slot="{ row }">
              <span class="text-overflow">{{
                `${formatFileSize(row.fileTotalSize).fileSize}${
                  formatFileSize(row.fileTotalSize).unit
                }`
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="请求时间" width="180">
            <template v-slot="{ row }">
              <span v-if="row.convertStatus === 1">--</span>
              <span v-if="row.convertStatus === 2">{{ row.startTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template v-slot="{ row }">
              <span v-if="row.convertStatus === 1">排队中</span>
              <span v-if="row.convertStatus === 2">转换中</span>
              <span v-if="row.convertStatus === 5">停止中</span>
            </template>
          </el-table-column>
          <el-table-column label="转换进度" width="240">
            <template v-slot="{ row }">
              <span v-if="row.convertStatus !== 2">--</span>
              <div v-if="row.convertStatus === 2" class="common-progress-box">
                <el-progress :show-text="false" :percentage="row.ratio" />
                <div class="custom-text">
                  <div class="text">{{ `${row.ratio}%` }}</div>
                  <div class="progress-name-box text-overflow">
                    {{ row.ratioMsg ? row.ratioMsg : "" }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  type="text"
                  size="small"
                  :disabled="row.convertStatus === 2 || row.convertStatus === 5"
                  @click="moveQueue(row, true)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  :disabled="row.convertStatus === 2 || row.convertStatus === 5"
                  @click="moveQueue(row, false)"
                  >下移</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  :disabled="row.convertStatus === 5"
                  @click="cancelProjectTransform(row)"
                  >取消</el-button
                >
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="common-empty-box">
              <bj-empty :image="require('@/assets/img/no-data.png')" class="empty-page">
                <template slot="description">
                  <div class="empty-text">抱歉，没有找到相关内容</div>
                </template>
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import Spin from "@/components/Spin.vue";

import {
  getSceneConvertQueueService,
  getProjectsConvertingProgress,
  moveConvertQueue,
  stopConvertingProject,
  delQueueProject,
} from "@/service/interface";

import { formatFileSize } from "@/utils/generalMethods";

export default {
  data() {
    return {
      tableLoading: false,
      queueList: [],

      requestCount: 0,
      maxRequestCount: 10,
    };
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
  },
  components: {
    DragDialog,
    Spin,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initQueueList();
      }
    },
  },
  methods: {
    initQueueList() {
      this.tableLoading = true;

      this.queryQueueList().then((queueList) => {
        this.queueList = queueList;
        if (!this.refreshQueueTimer) {
          this.refreshQueueTimer = setInterval(this.loopRequestQueueList, 500);
        }

        let convertingDataSets = this.queueList.filter(
          (el) => el.convertStatus === 2
        );

        if (convertingDataSets.length && !this.queueTimer) {
          this.updateConvertProgress(convertingDataSets);
          this.queueTimer = setInterval(
            this.updateConvertProgress,
            10000,
            convertingDataSets
          );
        }

        this.tableLoading = false;
      });
    },
    loopRequestQueueList() {
      this.requestCount++;
      if (this.requestCount > this.maxRequestCount) {
        this.refreshQueueTimer && clearInterval(this.refreshQueueTimer);
        this.refreshQueueTimer = null;
        this.requestCount = 0;
        return;
      }

      let convertingDatas = this.queueList.filter(
        (el) => el.convertStatus === 2
      );
      if (convertingDatas.length) {
        this.refreshQueueTimer && clearInterval(this.refreshQueueTimer);
        this.refreshQueueTimer = null;
        this.requestCount = 0;
        return;
      }
      this.queryQueueList().then((queueList) => {
        if (queueList.length) {
          this.queueList = queueList;

          let convertingDataSets = this.queueList.filter(
            (el) => el.convertStatus === 2
          );
          if (convertingDataSets.length && !this.queueTimer) {
            this.refreshQueueTimer && clearInterval(this.refreshQueueTimer);
            this.refreshQueueTimer = null;
            this.requestCount = 0;

            this.updateConvertProgress(convertingDataSets);
            this.queueTimer = setInterval(
              this.updateConvertProgress,
              10000,
              convertingDataSets
            );
          }
        }
      });
    },
    updateConvertProgress(convertingDataSets) {
      let dataSetIds = convertingDataSets.map((el) => el.dataSetId);
      getProjectsConvertingProgress({ dataSetIds }).then((response) => {
        if (response.isSuccess) {
          let dataList = response.data;
          for (let i = 0; i < dataList.length; i++) {
            let dataInfo = dataList[i];
            if (dataInfo.ratio === -1) {
              this.refreshQueueList();
              break;
            }

            let ratio = Math.round(dataInfo.ratio / 100) / 100;
            let find = this.queueList.find(
              (el) => el.dataSetId === dataInfo.dataSetId
            );

            if (ratio === 100) {
              this.refreshQueueList();
              break;
            } else {
              this.$set(find, "ratio", ratio);
              this.$set(find, "ratioMsg", dataInfo.message);
            }
          }
        }
      });
    },
    moveQueue(dataSetInfo, moveDirection) {
      let params = {
        dataSetId: dataSetInfo.dataSetId,
        moveDirection,
      };
      moveConvertQueue(params).then((response) => {
        if (response.isSuccess) {
          this.refreshQueueList().then(() => {
            this.$message.success("移动成功");
          });
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    cancelProjectTransform(dataSetInfo) {
      if (dataSetInfo.convertStatus === 2) {
        let params = {
          dataSetId: dataSetInfo.dataSetId,
          isStart: false,
        };
        stopConvertingProject(params).then((response) => {
          if (response.isSuccess) {
            this.refreshQueueList().then(() => {
              this.$message.success("取消成功");
            });
          } else {
            this.$message.error(response.errMsg);
          }
        });
      } else {
        let params = {
          dataSetId: dataSetInfo.dataSetId,
          isForce: true,
        };
        delQueueProject(params).then((response) => {
          if (response.isSuccess) {
            this.refreshQueueList().then(() => {
              this.$message.success("删除成功");
            });
          } else {
            this.$message.error(response.errMsg);
          }
        });
      }
    },
    refreshQueueList() {
      return new Promise((resolve) => {
        this.queryQueueList().then((queueList) => {
          this.queueList = queueList;

          queueList.forEach((item) => {
            let find = this.queueList.find(
              (el) => el.dataSetId === item.dataSetId
            );
            if (find && find.ratio) {
              item.ratio = find.ratio;
              item.ratioMsg = find.ratioMsg;
            }
          });

          let convertingDataSets = this.queueList.filter(
            (el) => el.convertStatus === 2 || el.convertStatus === 5
          );
          this.destroyQueueTimer();
          if (convertingDataSets.length && !this.queueTimer) {
            this.updateConvertProgress(convertingDataSets);
            this.queueTimer = setInterval(
              this.updateConvertProgress,
              10000,
              convertingDataSets
            );
          }
          resolve();
        });
      });
    },
    queryQueueList() {
      return new Promise((resolve) => {
        getSceneConvertQueueService({}).then((response) => {
          if (response.isSuccess) {
            let data = response.data;
            let queueList = this.formatQueueList(data);
            resolve(queueList);
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    formatQueueList(queueList) {
      let waiting = [];
      let converting = [];
      queueList.forEach((item) => {
        if (item.convertStatus === 2) {
          converting.push(item);
          if (!item.ratio) {
            item.ratio = 0;
            item.ratioMsg = "";
          }
        } else {
          waiting.push(item);
        }
        converting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex);
        waiting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex);
      });
      return [...converting, ...waiting];
    },
    cancel() {
      this.destroyQueueTimer();
      this.closeDialog();
    },
    destroyQueueTimer() {
      if (this.queueTimer) {
        clearInterval(this.queueTimer);
        this.queueTimer = null;
      }

      if (this.refreshQueueTimer) {
        clearInterval(this.refreshQueueTimer);
        this.refreshQueueTimer = null;
      }
    },
    formatFileSize,
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.queue-list-box {
  height: 500px;
  padding: 10px;

  .common-table-box {
    height: 100%;

    .common-button-box {
      display: flex;
    }

    .common-progress-box {
      display: flex;

      .el-progress {
        width: 80%;
      }

      .custom-text {
        width: 60px;
        line-height: 12px;
        font-size: 12px;
        text-align: center;

        .text {
          color: var(--success-status-color);
        }

        .progress-name-box {
          position: absolute;
          top: 5px;
          left: 0px;
          width: calc(100% - 50px);
          color: var(--success-status-color);
        }
      }

      &:hover {
        .custom-text {
          display: block;
        }
      }
    }
  }
}
</style>